import { render, staticRenderFns } from "./People.vue?vue&type=template&id=68bbeff3&scoped=true"
import script from "./People.vue?vue&type=script&lang=js"
export * from "./People.vue?vue&type=script&lang=js"
import style0 from "./People.vue?vue&type=style&index=0&id=68bbeff3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bbeff3",
  null
  
)

export default component.exports